
import {Phonemes} from "./phonemes.js"

// inspired by urbit's @p naming system
export const prefixes = new Phonemes([
	"nop", "bem", "bin", "bor", "buf", "cal", "cem", "cin", "cor", "cub", "dal", "dem", "din", "dor", "yol", "fal",
	"fen", "fir", "fol", "fum", "gal", "gem", "gin", "gor", "gul", "hal", "hem", "hin", "hor", "hul", "kal", "kem",
	"kin", "kor", "kul", "lam", "len", "lin", "lor", "lum", "mal", "men", "min", "mor", "mul", "nal", "nem", "nin",
	"nor", "nul", "pal", "pem", "pin", "por", "pul", "ral", "rem", "rin", "ror", "rum", "sal", "sem", "sin", "sor",
	"sun", "tal", "tem", "tin", "tor", "tul", "val", "vem", "vin", "vor", "vul", "wel", "wem", "win", "wor", "mel",
	"xel", "xin", "xor", "xul", "yal", "yen", "yin", "yor", "zul", "zan", "zen", "zin", "zor", "zun", "bac", "bed",
	"bod", "bun", "cad", "cog", "cus", "dab", "den", "dig", "dus", "fab", "fid", "fob", "gad", "gid", "gob", "hab",
	"hid", "hob", "jab", "jid", "job", "kab", "kid", "kob", "lab", "lid", "lob", "mab", "mid", "mob", "nab", "nid",
	"nob", "pab", "pid", "pob", "rab", "rid", "rob", "sab", "sid", "sob", "tab", "tid", "tob", "vab", "vid", "vob",
	"wab", "wid", "wob", "yab", "yid", "yob", "zab", "zid", "zob", "bar", "bel", "bol", "bur", "car", "cel", "col",
	"cur", "dar", "del", "dol", "dur", "far", "fel", "fur", "gar", "gel", "gol", "gur", "har", "hel", "hol", "bag",
	"bob", "jar", "jel", "jol", "jur", "kar", "kel", "kol", "kur", "lar", "lel", "lol", "lur", "mar", "bef", "mol",
	"mur", "nar", "nel", "nol", "nur", "par", "pel", "pol", "pur", "rar", "rel", "rol", "rur", "sar", "sel", "sol",
	"sur", "tar", "tel", "tol", "tur", "var", "vel", "vol", "vur", "war", "wol", "wur", "yar", "yel", "ded", "yur",
	"zar", "zel", "zol", "zur", "bam", "ban", "bat", "cam", "can", "cat", "dam", "dan", "dat", "fam", "fan", "ter",
	"ham", "han", "hat", "jam", "jan", "jat", "kam", "kan", "kat", "lan", "lat", "mam", "man", "mat", "wex", "wix",
])

